import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">Admin Dashboard</div>
      <ul className="sidebar-menu">
        <li className="sidebar-menu-item">
          <NavLink 
            to="/tasks/list" 
            className={({ isActive }) => 
              isActive ? "sidebar-menu-link active" : "sidebar-menu-link"
            }
          >
            Records
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/tasks/new" 
            className={({ isActive }) => 
              isActive ? "sidebar-menu-link active" : "sidebar-menu-link"
            }
          >
            Add New Task
          </NavLink>
        </li>
        <li className="sidebar-menu-item">
          <NavLink 
            to="/calendar" 
            className={({ isActive }) => 
              isActive ? "sidebar-menu-link active" : "sidebar-menu-link"
            }
          >
            Calendar
          </NavLink>
        </li>

        <li className="sidebar-menu-item">
          <NavLink 
            to="/newagent" 
            className={({ isActive }) => 
              isActive ? "sidebar-menu-link active" : "sidebar-menu-link"
            }
          >
            New Persona
          </NavLink>
        </li>


      </ul>
    </div>
  );
};

export default Sidebar;